import { useQuery } from '@apollo/client/react'
import { graphql, ResultOf, VariablesOf } from '@tucan/graphql'

export const QUERY = graphql(`
  query getSystemSettingValueByName($name: ID!) {
    setting: getSystemSettingValueByName(name: $name)
  }
`)

export type Data = ResultOf<typeof QUERY>
export type Variables = VariablesOf<typeof QUERY>

export const useSystemSettingValueQuery = (
  data: useQuery.Options<Data, Variables>,
): useQuery.Result<Data, Variables> => useQuery<Data, Variables>(QUERY, data)
